import React from "react";
import { useTable } from "../../Components/useTable";

const HostRequestList = () => {
  const type = "Join Agency Requests";
  const limitPerpage = 100;
  const pageRowslinit = [20 , 50 , 100];
  const headCells = [
    { id: "name", numeric: false, label: "Host Name" },
    { id: "rid", numeric: false, label: "RID" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "gender", numeric: false, label: "Gender" },
    { id: "country", numeric: false, label: "Country" },
    { id: "Agencyname", numeric: false, label: "Agency Name" },
    { id: "Agencycountry", numeric: false, label: "Agency Country" },
    { id: "code", numeric: false, label: "Agency Code" },
    { id: "usercode", numeric: false, label: "User Code" },
    { id: "level", numeric: false, label: "Level" },
    { id: "isActive1", numeric: false, label: "Status" },
    { id: "role", numeric: false, label: "Role" },
    { id: "status", numeric: false, label: "Status" },
    { id: "videoUrl", numeric: false, label: "Video Link" },
  ];


  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default HostRequestList;
